export default "__VITE_ASSET__R41_J20t__"